import React, { KeyboardEvent, MouseEvent } from 'react';
import { useHistory } from 'react-router';
import { Route } from 'react-router-dom';
import cx from 'classnames';

import { sanitiseLinks, wordpressImgToImgixURL } from 'Utilities';
import { useFeatureFlags } from 'Utilities/hooks';

import { GuideAuthorDetails } from '../../../containers/app/contentPages/wordPressPages/@types/Wordpress';
import { ContentAuthors } from '../../../containers/app/contentPages/wordPressPages/components/ContentAuthors/ContentAuthors';
import { COOKIE_POLICY_PATH } from '../../CookieBanner/cookieConsent.constants';
import { CookiePreferencesCentre } from '../../CookiePreferences/CookiePreferencesCentre';

import styles from './Page.scss';

type PageProps = {
  author?: GuideAuthorDetails;
  className?: string;
  content: string;
  editor?: string;
  modifiedDateTime?: string;
  title: string;
  wordpressContent: {
    className?: string;
  };
};

export const Page = ({
  author,
  className,
  content,
  editor,
  modifiedDateTime,
  title,
  wordpressContent,
}: PageProps) => {
  const history = useHistory();
  const { showWordpressGuideAuthorsPage } = useFeatureFlags();

  const linkClick = (e: MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    const url = target.getAttribute('href')
      || target.parentElement?.getAttribute('href');

    if (
      url
      && url.charAt(0) === '/'
      && !(e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey)
    ) {
      e.preventDefault();
      history.push(url);
    }

    if (url && /^#privacy-section/.test(url)) {
      e.preventDefault();
      target.classList.add('wp-privacy-link-hidden');
      document.getElementById(url.replace('#', ''))?.classList.add('active');
    }
  };

  const keyPress = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key.toLowerCase() === 'enter') {
      // Convert KeyboardEvent to MouseEvent-compatible object
      linkClick(e as unknown as MouseEvent<HTMLElement>);
    }
  };

  const showAuthor = showWordpressGuideAuthorsPage && author?.featured_author;

  return (
    <div
      className={cx(styles.component, className)}
      onClick={linkClick}
      onKeyDown={keyPress}
      {...wordpressContent}
      role="link"
      tabIndex={0}
    >
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      <Route component={CookiePreferencesCentre} path={COOKIE_POLICY_PATH} />
      {showAuthor && <ContentAuthors {...{ author, editor, modifiedDateTime }} />}
      <div
        dangerouslySetInnerHTML={{
          __html: sanitiseLinks(wordpressImgToImgixURL(content)),
        }}
      />
    </div>
  );
};
